// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dialog_dialogContainer__sad8W {
    position: fixed;
    left: 0;
    width: 100vw;
    height: -webkit-fill-available;
    height: 100vh;
}

.Dialog_dialog__fiyk- {
    position: absolute;
    top: 20px;
    left: 50%;
    z-index: 75;
    background-color: var(--color-106);
    outline: 0;
    background-clip: padding-box;
    border: 3px solid var(--color-130);
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transition: height 400ms;
    transition: height 400ms;
    cursor: default;
}

.Dialog_small__8QXb9 {
    width: 320px;
    margin-left: -160px;
}

.Dialog_medium__jfykL {
    width: 560px;
    margin-left: -280px;
}

.Dialog_large__A1n6G {
    width: 900px;
    margin-left: -450px;
}

.Dialog_xLarge__ecXCe {
    width: 1076px;
    margin-left: -538px;
}

.Dialog_fill__V-gol {
    width: 90%;
    margin-left: -45%;
}

.Dialog_dialogBackdrop__PnNPL {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 70;
    background-color: var(--color-106);
    opacity: .8;
}

.Dialog_dialogHeader__Guxgt {
    padding: 7px 15px;
    color: var(--color-100);
    overflow: hidden;
    line-height: 1;
}

.Dialog_dialogHeader__Guxgt h3 {
    line-height: inherit;
    padding: 8px 0;
    margin: 0;
    width: 85%;
    font-weight: 100;
    font-size: 12px;
    letter-spacing: 2px;
    text-transform: uppercase;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.Dialog_dialogHeader__Guxgt h3.Dialog_wrapTitle__KVE1C {
    width: 100%;
    white-space: unset;
    text-overflow: unset;
    overflow-wrap:break-word;
}

.Dialog_dialogCloseBtn__EtPd- {
    color: var(--color-icon-secondary);
    opacity: 1;
    font-weight: 400;
    font-size: 20px;
    margin: 10px;
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: 0;
    float: right;
    float: inline-end;
    line-height: 11px;
}

.Dialog_largeCloseBtn__q4hnE {
    color: var(--color-icon-secondary);
    font-size: 32px;
    margin: 12x;
    line-height: 18px;
}

.Dialog_dialogBody__BSWzp {
    position: relative;
    max-height: -webkit-calc(100vh - 180px);
    max-height: -moz-calc(100vh - 180px);
    max-height: calc(100vh - 180px);
    padding: 15px;
    overflow-y: auto;
    overscroll-behavior: contain;
}

.Dialog_dialogFooter__W9xGT {
    padding: 14px 15px 15px;
    margin-bottom: 0;
    text-align: right;
    border-top: 1px solid var(--color-118);
    background: var(--color-104);
}

.Dialog_hideBorder__CBM1S {
    border: none;
}

@media only screen and (max-width: 74.9375em) {
    .Dialog_large__A1n6G, .Dialog_xLarge__ecXCe {
        margin-left: -44vw;
        max-width: 98%;
        width: 88vw;
    }
}

@media only screen and (max-width: 47.9375em) {
    .Dialog_dialog__fiyk- {
        margin-left: -44vw;
        max-width: 98%;
        width: 88vw;
    }
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Dialog/Dialog.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,OAAO;IACP,YAAY;IACZ,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,kCAAkC;IAClC,UAAU;IACV,4BAA4B;IAC5B,kCAAkC;IAClC,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;IACpB,gCAAgC;IAChC,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,oCAAoC;IACpC,+BAA+B;IAC/B,aAAa;IACb,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;IACf;AACJ","sourcesContent":[".dialogContainer {\n    position: fixed;\n    left: 0;\n    width: 100vw;\n    height: -webkit-fill-available;\n    height: 100vh;\n}\n\n.dialog {\n    position: absolute;\n    top: 20px;\n    left: 50%;\n    z-index: 75;\n    background-color: var(--color-106);\n    outline: 0;\n    background-clip: padding-box;\n    border: 3px solid var(--color-130);\n    -webkit-transform: scaleY(1);\n    -ms-transform: scaleY(1);\n    transform: scaleY(1);\n    -webkit-transition: height 400ms;\n    transition: height 400ms;\n    cursor: default;\n}\n\n.small {\n    width: 320px;\n    margin-left: -160px;\n}\n\n.medium {\n    width: 560px;\n    margin-left: -280px;\n}\n\n.large {\n    width: 900px;\n    margin-left: -450px;\n}\n\n.xLarge {\n    width: 1076px;\n    margin-left: -538px;\n}\n\n.fill {\n    width: 90%;\n    margin-left: -45%;\n}\n\n.dialogBackdrop {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 70;\n    background-color: var(--color-106);\n    opacity: .8;\n}\n\n.dialogHeader {\n    padding: 7px 15px;\n    color: var(--color-100);\n    overflow: hidden;\n    line-height: 1;\n}\n\n.dialogHeader h3 {\n    line-height: inherit;\n    padding: 8px 0;\n    margin: 0;\n    width: 85%;\n    font-weight: 100;\n    font-size: 12px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.dialogHeader h3.wrapTitle {\n    width: 100%;\n    white-space: unset;\n    text-overflow: unset;\n    overflow-wrap:break-word;\n}\n\n.dialogCloseBtn {\n    color: var(--color-icon-secondary);\n    opacity: 1;\n    font-weight: 400;\n    font-size: 20px;\n    margin: 10px;\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    float: right;\n    float: inline-end;\n    line-height: 11px;\n}\n\n.largeCloseBtn {\n    color: var(--color-icon-secondary);\n    font-size: 32px;\n    margin: 12x;\n    line-height: 18px;\n}\n\n.dialogBody {\n    position: relative;\n    max-height: -webkit-calc(100vh - 180px);\n    max-height: -moz-calc(100vh - 180px);\n    max-height: calc(100vh - 180px);\n    padding: 15px;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n}\n\n.dialogFooter {\n    padding: 14px 15px 15px;\n    margin-bottom: 0;\n    text-align: right;\n    border-top: 1px solid var(--color-118);\n    background: var(--color-104);\n}\n\n.hideBorder {\n    border: none;\n}\n\n@media only screen and (max-width: 74.9375em) {\n    .large, .xLarge {\n        margin-left: -44vw;\n        max-width: 98%;\n        width: 88vw;\n    }\n}\n\n@media only screen and (max-width: 47.9375em) {\n    .dialog {\n        margin-left: -44vw;\n        max-width: 98%;\n        width: 88vw;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogContainer": `Dialog_dialogContainer__sad8W`,
	"dialog": `Dialog_dialog__fiyk-`,
	"small": `Dialog_small__8QXb9`,
	"medium": `Dialog_medium__jfykL`,
	"large": `Dialog_large__A1n6G`,
	"xLarge": `Dialog_xLarge__ecXCe`,
	"fill": `Dialog_fill__V-gol`,
	"dialogBackdrop": `Dialog_dialogBackdrop__PnNPL`,
	"dialogHeader": `Dialog_dialogHeader__Guxgt`,
	"wrapTitle": `Dialog_wrapTitle__KVE1C`,
	"dialogCloseBtn": `Dialog_dialogCloseBtn__EtPd-`,
	"largeCloseBtn": `Dialog_largeCloseBtn__q4hnE`,
	"dialogBody": `Dialog_dialogBody__BSWzp`,
	"dialogFooter": `Dialog_dialogFooter__W9xGT`,
	"hideBorder": `Dialog_hideBorder__CBM1S`
};
export default ___CSS_LOADER_EXPORT___;
